import React, { useEffect } from "react";
import { addDays } from "date-fns";
import { Button, Icon } from "semantic-ui-react";
import { Form, TextArea, Radio } from "formik-semantic-ui";
import { DateInput } from "semantic-ui-calendar-react";
import CurrencyInput from "react-currency-input-field";
import { PaymentMethods } from "utilities/dist/invoice/constants";
import { DateFormat } from "../helpers";

const InvoicePaymentEditorComponent = ({
    setFieldValue,
    setFieldTouched,
    values,
    onCancel,
    hasOrder,
    hasDelivery,
}) => {
    useEffect(() => {
        setFieldValue("payment_method", PaymentMethods.FINTECH);
    }, []);

    const handleChange = (e, { value }) => {
        setFieldValue("payment_method", value);
    };
    return (
        <>
            <Form.Group>
                <Form.Field required width={4}>
                    <label htmlFor="field_input_amount">Amount</label>
                    <div className="ui fluid left icon input">
                        <Icon name="dollar sign" />
                        <CurrencyInput
                            name="amount"
                            value={values.amount}
                            id="field_input_amount"
                            onValueChange={value => {
                                setFieldValue("amount", value);
                                setFieldTouched("amount");
                            }}
                        />
                    </div>
                </Form.Field>

                <DateInput
                    closable
                    animation="none"
                    name="received_at"
                    placeholder="Date"
                    iconPosition="left"
                    label="Received On"
                    value={values.received_at}
                    maxDate={addDays(new Date(), 3)}
                    dateFormat={DateFormat.toUpperCase()}
                    onChange={(e, data) => {
                        setFieldValue("received_at", data.value);
                        setFieldTouched("received_at");
                    }}
                />
            </Form.Group>

            <Form.Field required>
                <label>Method</label>
            </Form.Field>
            <Form.Group>
                <Form.Field>
                    <Radio
                        label="Fintech"
                        name="payment_method"
                        value={PaymentMethods.FINTECH}
                        checked={values.payment_method === PaymentMethods.FINTECH}
                        onChange={handleChange}
                        inputProps={{
                            "data-cy": "payment_method_fintech",
                        }}
                    />
                </Form.Field>
                <Form.Field>
                    <Radio
                        label="Check"
                        name="payment_method"
                        value={PaymentMethods.CHECK}
                        checked={values.payment_method === PaymentMethods.CHECK}
                        onChange={handleChange}
                        inputProps={{
                            "data-cy": "payment_method_check",
                        }}
                    />
                </Form.Field>
                {(!hasOrder || (hasOrder && !hasDelivery)) && (
                    <Form.Field>
                        <Radio
                            label="Prepaid"
                            name="payment_method"
                            value={PaymentMethods.PREPAID}
                            checked={values.payment_method === PaymentMethods.PREPAID}
                            onChange={handleChange}
                            inputProps={{
                                "data-cy": "payment_method_prepaid",
                            }}
                        />
                    </Form.Field>
                )}
                {(!hasOrder || (hasOrder && !hasDelivery)) && (
                    <Form.Field>
                        <Radio
                            label="Cash"
                            name="payment_method"
                            value={PaymentMethods.CASH}
                            checked={values.payment_method === PaymentMethods.CASH}
                            onChange={handleChange}
                            inputProps={{
                                "data-cy": "payment_method_cash",
                            }}
                        />
                    </Form.Field>
                )}
            </Form.Group>

            <TextArea name="note" label="Payment Note" />

            <br />
            <Button color="teal" type="submit" data-cy="save_payment">
                Save Payment
            </Button>
            <Button color="yellow" type="button" onClick={onCancel} data-cy="cancel_payment">
                Cancel
            </Button>
        </>
    );
};

export default InvoicePaymentEditorComponent;
